module.exports = __webpack_public_path__ + "static/media/sam-pumps.7d75c33c.png";